import React from 'react';
import { actions } from '@ecosystem/newron-design-system';
import { ViewType } from '@hooks/export/Model';

interface WithToggleButtonProps {
  value: ViewType;
  onChange: (value: ViewType | string) => void;
  children: React.ReactNode;
}

export const WithToggleButton = ({ onChange, value, children }: WithToggleButtonProps) => {
  const { ToggleButtons } = actions;

  return (
    <ToggleButtons onChange={onChange} value={value}>
      {children}
    </ToggleButtons>
  );
};
